export function normalizeVideoSearchText(value) {
  return String(value || "").normalize("NFC").toLocaleLowerCase("sv-SE").trim();
}

export function filterVideoCatalog(videos, { query = "", clipPath = "", favorites = new Set(), favoritesOnly = false } = {}) {
  const searchTerms = normalizeVideoSearchText(query).split(/\s+/).filter(Boolean);

  return (videos || []).filter((video) => {
    if (clipPath && video.clipPath !== clipPath) return false;
    if (favoritesOnly && !favorites.has(video.clipPath)) {
      return false;
    }
    if (!searchTerms.length) {
      return true;
    }

    const searchableText = normalizeVideoSearchText([
      video.title,
      video.description,
      video.folderPath,
      video.fileName
    ].join(" "));
    return searchTerms.every((term) => searchableText.includes(term));
  });
}
